<template>
  <div v-if="keyActive === keyShape" class="action action-txt">
    <div class="action_wrap book-viewer__cats__wrap">
      <h2 class="book-viewer__cats__title primary-color-txt font-size-24 font-sanpro-semibold">
        Hình vẽ
      </h2>
      <div class="action__detail">
        <template v-if="!shapeChoosed && !lineShapeChoosed && !arrowShapeChoosed">
          <div class="action__section">
            <label class="action__label secondary-color-txt font-size-16 font-sanpro-semi-bold">Hình khối</label>
            <div class="action__section__list display-flex-wrap">
              <div v-for="(item, index) of shapes" :key="index" class="item display-flex-center justify-content-center bg-color-light" @click="addShape(item.value)">
                <i class="font-size-17" :class="item.icon"></i>
              </div>
            </div>
          </div>
          <div class="action__section">
            <label class="action__label secondary-color-txt font-size-16 font-sanpro-semi-bold">Đường</label>
            <div class="action__section__list display-flex-wrap">
              <div
                v-for="(item, index) of lines"
                :key="index"
                class="item display-flex-center justify-content-center bg-color-light"
                @click="addShapeLine(item.value)"
                :class="{'active': lineShapeChoosed === item.value}"
              >
                <i class="font-size-17" :class="item.icon"></i>
              </div>
            </div>
          </div>
          <div class="action__section">
            <label class="action__label secondary-color-txt font-size-16 font-sanpro-semi-bold">Biểu tượng</label>
            <div class="action__section__list display-flex-wrap">
              <div
                v-for="(item, index) of icons"
                :key="index"
                class="item display-flex-center justify-content-center bg-color-light"
                @click="addShapeArrow(item.value)"
                :class="{'active': arrowShapeChoosed === item.value}"
              >
                <i class="font-size-17" :class="item.icon"></i>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="action__section">
            <label class="action__label secondary-color-txt font-size-16 font-sanpro-semi-bold">Thao tác</label>
            <div class="action__section__list display-flex-wrap">
              <div class="item display-flex-center justify-content-center bg-color-light" @click="removeObjectCurr()">
                <i class="icon-lesson-trash font-size-17"></i>
              </div>
              <div class="item display-flex-center justify-content-center bg-color-light" @click="handleCopyPaste()">
                <i class="icon-lesson-copy font-size-17"></i>
              </div>
            </div>
          </div>
          <div v-if="(shapeChoosed || arrowShapeChoosed) && !lineShapeChoosed" class="action__section">
            <label class="action__label secondary-color-txt font-size-16 font-sanpro-semi-bold">Kiểu</label>
            <div class="action__section__list display-flex-wrap">
              <div
                v-for="(item, index) of shapeTypes"
                :key="index"
                class="item display-flex-center justify-content-center bg-color-light"
                :class="{'active': shapeFillType === item.value}"
                @click="setShapeType(item.value)"
              >
                <i class="font-size-17" :class="item.icon"></i>
              </div>
            </div>
          </div>
          <div class="action__section">
            <SidebarActionColor :colorActive="colorFillCurr" @changeColor="changeColor" />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import SidebarActionColor from './SidebarActionColor.vue'
import { STORE_KEY, KEY_SHAPE } from './../../_store/constants'
import mixinsDetailLesson from './../../_store/mixinsDetailLesson'

export default {
  name: 'SidebarActionShape',
  props: {
    keyActive: String
  },
  components: {
    SidebarActionColor
  },
  mixins: [ mixinsDetailLesson ],
  data () {
    return {
      keyShape: KEY_SHAPE,
      shapeChoosed: '',
      lineShapeChoosed: '',
      arrowShapeChoosed: '',
      colorFillCurr: '#0F3DBA',
      shapeFillType: 'full', //full, transparent, border-dashed
      shapes: [
        {value: 'rect', icon: 'icon-lesson-rec'},
        // {value: 'rectangle-1', icon: 'icon-lesson-rectangle-1'},
        // {value: 'rectangle-2', icon: 'icon-lesson-rectangle-2'},
        {value: 'rec-corner', icon: 'icon-lesson-rec-corner'},
        // {value: 'rectangle-corner-1', icon: 'icon-lesson-rectangle-corner-1'},
        // {value: 'rectangle-corner-2', icon: 'icon-lesson-rectangle-corner-2'},
        {value: 'triangle', icon: 'icon-lesson-triangle'},
        {value: 'triangle-2', icon: 'icon-lesson-triangle-2'},
        {value: 'circle', icon: 'icon-lesson-circle'},
        {value: 'rhombus', icon: 'icon-lesson--rhombus'},
        {value: 'parallelogram', icon: 'icon-lesson-parallelogram'},
        {value: 'trapezoid', icon: 'icon-lesson-trapezoid'},
        {value: 'pentagon', icon: 'icon-lesson-pentagon'},
        {value: 'hexagon', icon: 'icon-lesson-hexagon'},
        {value: 'ellipse', icon: 'icon-lesson-hexagon'}
      ],
      lines: [
        {value: 'line-1', icon: 'icon-lesson-line-1'},
        {value: 'line-2', icon: 'icon-lesson-line-2'},
        {value: 'line-3', icon: 'icon-lesson-line-3'},
        {value: 'line-4', icon: 'icon-lesson-line-4'},
        {value: 'line-5', icon: 'icon-lesson-line-5'},
        {value: 'line-6', icon: 'icon-lesson-line-6'},
        {value: 'line-7', icon: 'icon-lesson-line-7'},
        {value: 'line-8', icon: 'icon-lesson-line-8'}
      ],
      icons: [
        {value: 'arrow-l', icon: 'icon-lesson-arrow-l'},
        {value: 'arrow-r', icon: 'icon-lesson-arrow-r'},
        {value: 'arrow-u', icon: 'icon-lesson-arrow-u'},
        {value: 'arrow-d', icon: 'icon-leeson-arrow-d'},
        {value: 'arrow-2', icon: 'icon-lesson-arrow-2'}
      ],
      shapeTypes: [
        {value: 'full', icon: 'icon-lesson-shape-kind-1'},
        {value: 'transparent', icon: 'icon-lesson-shape-kind-2'},
        {value: 'border_dashed', icon: 'icon-lesson-shape-kind-3'}
      ],
      // slideObj: null,
      colorTransparent: 'rgba(255,255,255,0)'
    }
  },
  computed: {
    ...mapState(STORE_KEY, ['slideCurr', 'slidesMain', 'slideIndexVisible'])
  },
  watch: {
    keyActive (newVal) {
      newVal === KEY_SHAPE && this.resetDataChoosed()
    }
  },
  mounted () {
    this.initShape()
  },
  methods: {
    ...mapActions(STORE_KEY, ['acSetObjActiSlide', 'acSetSlideCurr', 'acSetSlidesMain']),

    initShape () {
      let self = this
      this.slideCurr.on("mouse:up", function(t) {
        if (t.isClick && !t.target) {
          self.resetDataChoosed()
        } else if (t.isClick && t.target && t.target.type_detail && !t.target.type_detail.includes('line') && !t.target.type_detail.includes('arrow')) {
          self.shapeChoosed = t.target.type
          self.colorFillCurr = t.target.fill
        } else if (t.isClick && t.target && t.target.type_detail && t.target.type_detail.includes('line')) {
          self.lineShapeChoosed = t.target.type
          self.colorFillCurr = t.target.fill
        } else if (t.isClick && t.target && t.target.type_detail && t.target.type_detail.includes('arrow')) {
          self.arrowShapeChoosed = t.target.type
          self.colorFillCurr = t.target.fill
        } 
        self.saveToImage()
        self.saveToSVG()
      });
    },

    resetDataChoosed () {
      this.colorFillCurr = '#0F3DBA'
      this.shapeChoosed = null
      this.lineShapeChoosed = null
      this.arrowShapeChoosed = null
    },

    removeObjectCurr () {
      let area = this.slideCurr.getActiveObject()
      area && this.slideCurr.remove(area)
    },

    changeColor (val) {
      // console.log('Change color: ABC')
      let objCurr = this.slideCurr.getActiveObject()
      this.colorFillCurr = val
      this.shapeFillType === 'full' && this.changeStyleForArea('fill', val)
      this.changeStyleForArea('stroke', val)

      // console.log('AAAAA', objCurr, objCurr.type)
      if (objCurr.type === 'Group') {
        objCurr._objects.map(obj => {
          obj.set('fill', val).setCoords();
          obj.set('stroke', val).setCoords();
        })
        this.slideCurr.renderAll();
        this.handleSaveCanvas()
      }
    },

    setShapeType (val) {
      this.shapeFillType = val
      switch(val) {
        case 'border_dashed':
          this.changeStyleForArea('fill', this.colorTransparent)
          this.changeStyleForArea('strokeDashArray', [5, 5])
          break;
        case 'transparent':
          this.changeStyleForArea('fill', this.colorTransparent)
          this.changeStyleForArea('strokeDashArray', [])
          break;
        default:
          this.changeStyleForArea('fill', this.colorFillCurr)
          this.changeStyleForArea('strokeDashArray', [])
          break;
      }
    },

    handleCopyPaste () {
      this.copy()
      this.paste()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>